import { FiscalDashboard } from './FiscalDashboard';

/** Index route of the fiscal section — stats dashboard (Task 14). */
export function FiscalDashboardPage() {
  return <FiscalDashboard />;
}
